<div class="kt-portlet">
    <div class="kt-portlet-body">
        <div class="row">
            <div class="col-md-12">
                <div class="map-container">
                    <div #map class="map-element"></div>
                </div>
            </div>            
        </div>
    </div>
</div>